import { reactive, ref } from 'vue'

import api from '@/store/api'

export function useStorefrontSeo() {
  const form = reactive({ service_area: '', description: '' })
  const suggestions = reactive({ service_area: '', description: '' })
  const preview = ref({ title: '', description: '', url: '' })
  const serviceAreaEditable = ref(true)

  const read = response => {
    const data = response?.data || {}
    form.service_area = data.service_area || ''
    form.description = data.description || ''
    suggestions.service_area = data.suggested_service_area || ''
    suggestions.description = data.suggested_description || ''
    preview.value = data.preview || { title: '', description: '', url: '' }
    serviceAreaEditable.value = data.service_area_editable !== false
  }

  const load = () => api.call('GET', 'storefront_seo', {}, { receive: false }).then(read)

  const save = () =>
    api
      .call(
        'PUT',
        'storefront_seo',
        { storefront_seo: { service_area: form.service_area, description: form.description } },
        { receive: false }
      )
      .then(read)

  return { form, suggestions, preview, serviceAreaEditable, load, save }
}
